<template>
    <div id="app" :class="['wrapper', 'is-' + locale]">
        <transition name="header">
            <Header class="is-top" v-if="isTop && !isMain"/>
        </transition>
        <transition name="header">
            <Header v-if="!isTop"/>
        </transition>
        <transition name="page">
            <router-view class="contents"/>
        </transition>
        <Footer/>
        <transition name="top-button">
            <div class="toTop"
                v-show="!isTop"
                :class="isBottom ? 'is-bottom' : ''"></div>
        </transition>
    </div>
</template>

<script>
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import VueScrollTo from 'vue-scrollto'

export default {
    name: 'App',
    components: {
        Header, Footer
    },
    metaInfo: {
        title: '큐브플랫폼',
        titleTemplate: '%s'
    },
    data: function () {
        return {
            isTop: true,
            isMain: true,
            isBottom: false
        }
    },
    methods: {
        headerTop: function () {
            var visual = '' || document.getElementsByClassName('visual')[0]
            if (window.pageYOffset < visual.scrollHeight * 0.8) {
                this.isTop = true
            } else {
                this.isTop = false
            }
            return this.isTop
        },
        headerMain: function () {
            this.$route.path === '/' ? this.isMain = true : this.isMain = false
            return this.isMain
        },
        goToTop: function () {
            var toTop = document.getElementsByClassName('toTop')[0]
            toTop.addEventListener('click', function () {
                VueScrollTo.scrollTo({ y: 0 }, 500)
            })
        },
        scrollBottom: function () {
            var scrollTop = window.pageYOffset
            var clientHeight = document.documentElement.clientHeight
            var scrollHeight = document.documentElement.scrollHeight
            var footer = document.getElementsByClassName('footer')[0]
            if (scrollTop + clientHeight >= scrollHeight - (footer.scrollHeight * 0.2)) {
                this.isBottom = true
            } else {
                this.isBottom = false
            }
        }
    },
    computed: {
        locale: function () {
            return this.$store.getters.getLocale
        }
    },
    mounted: function () {
        const self = this
        window.addEventListener('load', function () {
            self.headerTop()
            self.headerMain()
        })
        window.addEventListener('scroll', function () {
            self.headerTop()
            self.scrollBottom()
        })
        this.goToTop()
    },
    updated: function () {
        this.headerTop()
        this.headerMain()
        var leaveActive = '' || document.getElementsByClassName('page-leave-active')[0]
        var leaveActiveTo = '' || document.getElementsByClassName('page-leave-active-to')[0]
        if (leaveActive) {
            leaveActive.style.transform = `translateY(-${this.$store.getters.getFromScroll}px)`
        }
        if (leaveActiveTo) {
            leaveActiveTo.style.transform = `translateY(-${this.$store.getters.getFromScroll}px)`
        }
    }
}
</script>

<style lang="scss">
@import './assets/style/reset.scss';
@import './assets/style/NotoSansKR.css';
@import './assets/style/NotoSansJP.css';
@import './assets/style/Lato.css';
@import './assets/style/common.scss';
@import '@/assets/style/mixin.scss';
.wrapper {
    position: relative;
    & > .contents {
        width: 100%;
        margin: 0;
        padding: 0;
    }
    & > .toTop {
        position: fixed;
        right: 40px;
        bottom: 40px;
        z-index: 9999;
        width: 50px;
        height: 50px;
        background: #fff;
        // box-shadow: 3px 3px 50px 8px rgba(0, 0, 0, 0.1);
        box-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
        transform: translateY(0);
        transition: transform 500ms, opacity 500ms;
        cursor: pointer;

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 100%;
            background: url(assets/image/common/top-arrow.png) no-repeat center;
            background-size: 20px auto;
        }
        &.is-bottom {
            transform: translateY(-80px);
        }
    }
    @include under-tablet {
        overflow: hidden;
        & > .toTop {
            width: 50px;
            height: 50px;
            right: 28px;
            bottom: 28px;
            &::before {
                background-size: 16px auto;
            }
            &.is-bottom {
                transform: translateY(-30vw);
            }
        }
    }
    @include mobile {
        & > .toTop {
            right: 20px;
            bottom: 20px;
        }
    }
}
@include over-desktop {
    .page-enter,
    .page-leave-to {
        opacity: 0;
    }
    .page-enter-to,
    .page-leave {
        opacity: 1;
    }
    .page-enter-active {
        position: absolute;
        top: 0;
        transition: opacity 100ms;
    }
    .page-leave-active {
        position: absolute;
        top: 0;
        z-index: -1;
        transition: opacity 500ms;
    }
    .page-enter-active + .footer,
    .page-leave-active + .footer {
        position: absolute;
        bottom: 0;
    }
}
.header-enter-active,
.header-leave-active {
transition-duration: 750ms;
transition-property: opacity;
transition-timing-function: ease;
}
.header-enter,
.header-leave-active {
opacity: 0
}
@include under-tablet () {
    .header.is-open.header-enter-active,
    .header.is-open.header-leave-active {
        transition: none;
    }
    .header.is-open.header-enter,
    .header.is-open.header-leave-active {
    opacity: 1
    }
}
.top-button-enter-active,
.top-button-leave-active {
transition-duration: 500ms;
transition-property: opacity;
transition-timing-function: ease;
}
.top-button-enter,
.top-button-leave-active {
opacity: 0
}
// for scrollama
.resize-observer {
    display: none;
}

@include over-desktop {
    .tablet-break,
    .under-tablet-break,
    .mobile-break {
        display: none;
    }
}
@include tablet {
    .desktop-break,
    .mobile-break {
        display: none;
    }
}
@include mobile {
    .desktop-break,
    .tablet-break {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue